<dashboardnav>

  <cradua-racktrayref
  [cabinetshelfrefs]="cabinetshelfrefs$ | async"
  [racktrayrefs]="racktrayrefs$ | async"

  (changeEmit)="onSubmitRackTrayRef($event)"
  (deleteEvent)="onDeleteRackTrayRef($event)"
  *ngIf="
  !(isLoadingCabinetShelfRef$ | async ) &&
  !(isLoadingRackTrayRef$ | async )
  "
  >
  </cradua-racktrayref>

  <mrsoftapps-epims-reference-spinner
  *ngIf="
  (isLoadingCabinetShelfRef$ | async ) ||
  (isLoadingRackTrayRef$ | async )
  "
>
  </mrsoftapps-epims-reference-spinner>
</dashboardnav>
